import Button, { ButtonProps } from '@/components/Button'
import FileUploaderModal from '@/components/modals/FileUploaderModal'
import { useCanUploadFiles } from '@/hooks'
import React from 'react'
interface FileUploadButtonProps extends Omit<ButtonProps, 'onClick'> {
  contextType?: 'customer' | 'deal' | 'car' | 'report' | 'user'
  contextId?: string | number
  multiple?: boolean
  acceptedTypes?: string
  title?: string
  buttonText?: string
}

const FileUploadButton: React.FC<FileUploadButtonProps> = ({
  contextType,
  contextId,
  multiple,
  acceptedTypes,
  title,
  buttonText = 'העלאת קבצים',
  ...buttonProps
}) => {
  const canUploadFiles = useCanUploadFiles()
  const [isModalOpen, setIsModalOpen] = React.useState(false)

  if (!canUploadFiles) return null

  return (
    <>
      <Button
        className="main-btn outline white"
        onClick={() => setIsModalOpen(true)}
        {...buttonProps}
      >
        {buttonText}
      </Button>

      <FileUploaderModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        contextType={contextType}
        contextId={contextId}
        multiple={multiple}
        acceptedTypes={acceptedTypes}
        title={title}
      />
    </>
  )
}

export default FileUploadButton
